import React, { lazy } from 'react';
import { Play } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WavyDivider } from '../components/WavyDivider';
import { useSeo } from '../lib/useSeo';
export function CreativeCorner() {
  useSeo({
    title: 'Creative Corner',
    description: 'Unveil your hidden gifts and indulge in art and craft. Join me for painting, drawing, writing, floral arrangements, and culinary journeys.',
    path: '/creative-corner',
    image: 'https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?auto=format&fit=crop&q=80&w=2000'
  });
  return <div className="min-h-screen flex flex-col bg-cream" data-id="element-301">
      <Header data-id="element-302" />

      <section className="relative h-[65vh] min-h-[480px] flex items-center justify-center overflow-hidden" data-id="element-303">
        <div className="absolute inset-0 z-0" data-id="element-304">
          <img src="https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?auto=format&fit=crop&q=80&w=2000" alt="Zen garden sand with stones" className="w-full h-full object-cover" data-id="element-305" />
          <div className="absolute inset-0 bg-white/50" data-id="element-306"></div>
        </div>
        <div className="relative z-10 text-center px-6 mt-16" data-id="element-307">
          <h1 className="font-serif text-charcoal drop-shadow-sm" data-id="element-308">
            <span className="block text-5xl md:text-7xl mb-4" data-id="element-309">
              Creative corner
            </span>
            <span className="block text-xl md:text-2xl font-serif italic text-charcoal-50" data-id="element-310">
              made by Milangela's Soul Garden
            </span>
          </h1>
        </div>
        <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none" data-id="element-311">
          <WavyDivider fill="#F5F5F5" data-id="element-312" />
        </div>
      </section>

      <section className="bg-cream-100 py-20 px-6" data-id="element-313">
        <div className="max-w-4xl mx-auto mb-14" data-id="element-314">
          <a href="https://www.youtube.com/watch?v=QEB_XDkymGc" target="_blank" rel="noopener noreferrer" className="group relative block aspect-video rounded-2xl overflow-hidden shadow-soft bg-charcoal" data-id="element-315">
            <img src="https://img.youtube.com/vi/QEB_XDkymGc/maxresdefault.jpg" alt="How to prepare a Christmas cake" loading="lazy" className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" data-id="element-316" />
            <div className="absolute inset-0 bg-charcoal/30 flex items-center justify-center" data-id="element-317">
              <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform" data-id="element-318">
                <Play size={26} fill="#3A3A38" className="text-charcoal ml-1" data-id="element-319" />
              </div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/70 to-transparent" data-id="element-320">
              <p className="text-white text-sm font-medium tracking-wide drop-shadow" data-id="element-321">
                How to prepare a Christmas cake? — Milangela
              </p>
            </div>
          </a>
        </div>

        <div className="max-w-2xl mx-auto text-center space-y-6 text-charcoal-50 font-light leading-relaxed" data-id="element-322">
          <p data-id="element-323">
            How to unveil the hidden gifts, fulfill wishes to indulge in art and
            craft that have been accused to be of no value and "shamed out of
            us". Brené Brown argues that{' '}
            <em className="text-charcoal font-serif" data-id="element-324">
              "Unused creativity is not benign. It turns into grief, sorrow,
              rage, judgment, shame…"
            </em>
          </p>
          <p data-id="element-325">
            Be prepared for painting, drawing, writing, making floral
            arrangements, sewing, knitting, culinary journeys, and more.
          </p>
          <p className="font-serif italic text-xl md:text-2xl text-charcoal pt-4" data-id="element-326">
            Join me and be amazed at what happens…
          </p>
        </div>
      </section>

      {/* QUOTE SECTION */}
      <section className="relative bg-cream-100 py-24 px-6 overflow-hidden" data-id="element-327">
        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-328">
          <div className="text-6xl font-serif text-sage-600 leading-none mb-4" data-id="element-329">
            "
          </div>
          <p className="font-serif text-3xl md:text-4xl text-charcoal italic leading-snug mb-5" data-id="element-330">
            One day or day one?
          </p>
          <p className="text-charcoal-50 text-sm tracking-widest uppercase" data-id="element-331">
            — You decide
          </p>
        </div>
      </section>
      <div className="relative bg-cream-100 pointer-events-none" data-id="element-332">
        <WavyDivider fill="#3A3A38" data-id="element-333" />
      </div>

      <Footer data-id="element-334" />
    </div>;
}